var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcCheckCircle = function SvgIcCheckCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M19.957 11.785v.693a8.454 8.454 0 0 1-8.479 8.479A8.454 8.454 0 0 1 3 12.478 8.454 8.454 0 0 1 11.478 4c1.156 0 2.39.231 3.469.77.385.155.54.617.385 1.003-.154.385-.617.54-1.002.385-.925-.385-1.85-.616-2.852-.616a6.908 6.908 0 0 0-6.936 6.936 6.908 6.908 0 0 0 6.936 6.937 6.908 6.908 0 0 0 6.937-6.937v-.693c0-.463.308-.771.77-.771.463 0 .772.308.772.77zm.539-6.783a.745.745 0 0 0-1.079 0l-7.939 7.939-1.772-1.773a.745.745 0 0 0-1.08 0 .745.745 0 0 0 0 1.079l2.313 2.312a.833.833 0 0 0 .54.232.833.833 0 0 0 .539-.232l8.478-8.478a.745.745 0 0 0 0-1.079z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcCheckCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-check-circle.8aed0d36136497a8900f9a0a77a5b65c.svg";